/* eslint-disable */
import { useEffect } from 'react';

export function useIsLoaded(method: VoidFunction) {
  useEffect(method, []);
}
